<template>
  <div class="p-4">
    <h1>Messages</h1>

    <div
      v-for="message in incomming_messages_all"
      :key="message.$key"
      class="card d-flex m-2 p-2" style="flex-direction: row">
      <user-mini-avatar :user-id="message.senderUserId" :show-name="true" size="normal" style="align-self: center" />

      <div style="flex: 1">
        <!-- <el-badge is-dot v-if="message.unread"></el-badge> -->
        <div v-if="message.unread">
          <strong>{{message.message}}</strong>
        </div>
        <div v-else>
          {{message.message}}
        </div>
        <template v-if="message.unread">
          <a href="#" @click="onMarkMessageAsSeen(message)">mark as seen</a> |
        </template>
        <a href="#" @click="onSendMessage(message)">reply</a>
      </div>
      <div class="small text-muted">{{message.createdAt|fromNow}}</div>
    </div>
    <!-- incomming_messages: <pre>{{incomming_messages.itemsAsArray()}}</pre> -->

  </div>
</template>

<script>
import SendMessagePrompt from "@/components/Mixins/Prompts/SendMessagePrompt"
import util from '@/util'

// TODO: Show list of contact
// TODO: Allow to select on contact
// TODO: Always show message input + send button
// TODO: See linked in messages

export default {
  name: "MessagesPage",
  mixins: [ SendMessagePrompt ],
  data() {
    return {
      showMessageMenu: false
    };
  },
  computed: {
    incomming_messages() {
      return this.$models.userMsgInbox.subscribeList() // TODO: subscribeQuery
    },
    incomming_messages_all() {
      return this.incomming_messages.itemsAsArray()
        .sort(util.sorter.by_createdAt)
        .reverse()
    }
  },
  methods: {
    onMarkMessageAsSeen(message) {
      message.update({ unread: false })
    },

    onSendMessage(message) {
      console.log("message", message)
      this.$send_msg_prompt({ receiverUserId: message.senderUserId })
      .then(({ done, messageContent }) => {
        this.$api.contact_send_message({
          receiverUserId: message.senderUserId,
          message: messageContent
        })
        done();
      })
    },
  }
};
</script>
